import { render, staticRenderFns } from "./ListRoles.vue?vue&type=template&id=07c609f7&"
import script from "./ListRoles.vue?vue&type=script&lang=js&"
export * from "./ListRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports